import { render, staticRenderFns } from "./CloseDialogue.vue?vue&type=template&id=236edc09"
import script from "./CloseDialogue.vue?vue&type=script&lang=js"
export * from "./CloseDialogue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports